import { render, staticRenderFns } from "./AboutRedLion.vue?vue&type=template&id=06df4d6c&scoped=true"
import script from "./AboutRedLion.vue?vue&type=script&lang=js"
export * from "./AboutRedLion.vue?vue&type=script&lang=js"
import style0 from "./AboutRedLion.vue?vue&type=style&index=0&id=06df4d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df4d6c",
  null
  
)

export default component.exports